module.exports = __webpack_public_path__ + "img/logo.77758509.svg";